import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faChevronRight, faChevronLeft, faTimes } from '@fortawesome/pro-regular-svg-icons';

// actions
import { loadShopperDoctors } from '../../../actions/doctors';

// components
import { ModalBase } from '../../../common/components';
import DoctorRow from './DoctorRow';
import Radius from './inputs/Radius';
import Search from './inputs/Search';
import Specialty from './inputs/Specialty';
import Zipcode from './inputs/Zipcode';
import Finish from './inputs/Finish';

function DoctorsModal() {
  const dispatch = useDispatch();
  const {
    quote,
    quote: { zip: shopperZip },
    doctors: { doctorList, doctorSearch },
    modals: { doctorsModal: modalOpen },
  } = useSelector(store => store);
  const [ error, setError ] = useState('');
  const [ loadingMedcab, setLoadingMedcab ] = useState(false);

  useEffect(() => {
    if (!doctorList.length) {
      setLoadingMedcab(true);
      loadShopperDoctors(
        quote.shopperUsername,
        quote.zip,
        quote.cpsID,
        quote.planYear,
      ).then((data) => {
        dispatch({ type: 'LOAD_SHOPPER_DOCTORS', doctorList: data });
        setLoadingMedcab(false);
      }).catch((err) => {
        setLoadingMedcab(false);
        if (err.response.status !== 404) {
          console.log('modals/doctors.componentDidMount: ', err);
        }
      });
    }
  }, []);

  useEffect(() => {
    dispatch({ type: 'SET_DOCTORS_ZIPCODE', payload: shopperZip });
    // set the default search radius to be 15
    dispatch({ type: 'SET_DOCTORS_RADIUS', payload: 15 });
  }, [modalOpen]);

  return (
    <ModalBase
      allowOverlayClickClose
      isOpen={modalOpen}
      padding="0px"
      width="90%"
      style={{ maxHeight: '97%' }}
      closeModalAction={() => {
        dispatch({ type: 'CLEAR_SELECTED_DOCTOR' });
        dispatch({ type: 'CLOSE_MODAL', modal: 'doctorsModal' });
      }}
    >
      <div
        className="col"
        style={{
          paddingTop: '0px',
          paddingBottom: '0px',
          paddingRight: '50px',
          paddingLeft: '50px',
        }}
      >
        <div className="row">
          <h5>Select from client&apos;s doctor list</h5>
        </div>
        <div className="row mb-3 text-muted">
          <div className="col">
            NOTE: doctors that are not in-network
            <span className="fw-bold mx-1">or are not registered as a PCP with this plan</span>
            are greyed out and cannot be selected. A doctor may also be greyed out if our data provider
            does not supply the carrier&apos;s PCP id, in which case please check the carrier&apos;s provider
            listing directly.
            In the &apos;Accepting New Patients&apos; column
            a green check indicates the provider is accepting new patients, a red &apos;x&apos; indicates
            they are not, and a grey question mark indicates our data provider is not sending data
            for this provider.
          </div>
        </div>
        <div
          className="row doctor-table"
          style={{
            height: '170px',
            overflow: 'scroll',
            overflowX: 'hidden',
          }}
        >
          <table className="table">
            <thead>
              <tr>
                <th />
                <th>Name</th>
                <th>Specialty</th>
                <th>Accepting New Patients</th>
                <th>Address</th>
                <th />
              </tr>
            </thead>
            {loadingMedcab ? (
              <tbody>
                <tr>
                  <td colSpan="4" className="text-center">
                    <i className="text-muted">Loading doctors...</i>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {Boolean(doctorList.length) && doctorList.map((d) => (
                  <DoctorRow key={`${d.name}${d.address}`} checkNetwork doctor={d} showStar />
                ))}
                {!doctorList.length && (
                  <tr>
                    <td colSpan="5" className="text-center">
                      <p className="text-muted">No doctors were selected in the quoting tool</p>
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>

        <div className="row mt-4">
          <h5>Or search for a doctor</h5>
        </div>
        <div className="row mb-3 text-muted">
          <div className="col">
            NOTE: Search results will include only in-network doctors
            <i className="fw-bold mx-1">who are registered as a PCP with this plan.</i>
            If you see results that are greyed out, our data provider is not supplying
            the necessary IDs for this carrier. Please check the carrier&apos;s provider listing
            directly in this case.
          </div>
        </div>

        <div className="row">
          <div className="col-2">
            <Specialty />
          </div>
          <div className="col-2">
            <Radius />
          </div>
          <div className="col-2">
            <Zipcode />
          </div>
          <div className="col">
            <Search setError={setError} />
          </div>
        </div>

        <div
          className="row doctor-table"
          style={{
            height: '300px',
            overflow: 'scroll',
            overflowX: 'hidden',
          }}
        >
          <table className="table mb-4">
            <thead>
              <tr>
                <th />
                <th>Name</th>
                <th>Specialty</th>
                <th>Accepting New Patients</th>
                <th>Address</th>
              </tr>
            </thead>
            {error && (
              <tbody>
                <tr>
                  <td colSpan="4" className="text-center">
                    <p className="text-danger">{error}</p>
                  </td>
                </tr>
              </tbody>
            )}
            {(!error && doctorSearch.length) ? (
              <tbody>
                {doctorSearch.map((d) => (
                  <DoctorRow key={`${d.name}${d.address}`} doctor={d} checkNetwork={false} />
                ))}
              </tbody>
            ) : (
              <tbody />
            )}
          </table>
        </div>
      </div>

      <div className="col doctor-footer mt-1 ps-4">
        <div className="row">
          <Finish />
        </div>
      </div>

    </ModalBase>
  );
}

export default DoctorsModal;
